import { Component } from '@angular/core';

@Component({
    selector: 'platform-failed-login',
    template: `<p>Login failed. Please try again.</p>`,
    styles: [''],
})
export class FailedLoginComponent {}
